import React, { useEffect, useState } from "react";
import { ResponseInterface } from "../../../interfaces/ResponseInterface";
import { config } from "../../../config";
import { useHistory } from "react-router-dom";
import { getSettingsEconomicPath } from "../../../routes/settingsPaths";
import { RouteDefine } from "../../../routes/RouteDefine";
import { useDispatch } from "react-redux";
import { setToast } from "../../../app/rootReducer";
import { QHelpers } from "../../../common/helpers";
import { GeneralConstant } from "../../../common/constant/GeneralConstant";
import UserApi from "../../../common/api/functions/User";
import SetupApi from "../../../common/api/functions/Setup";
import { getEconomicReconnectReturnPath, consumeEconomicReconnectFlag } from "../../../common/helpers/economicOAuth";
import { useTranslation } from "react-i18next";
import { resolveOnboardingPath } from "../../../common/helpers/onboardingResume";
import { saveEconomicRegistrationSession } from "../../../common/helpers/economicRegistrationSession";

export function EconomicMarket() {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const objectParams = QHelpers.object.convertParamUrlToObject(window.location.search);

    useEffect(() => {
        if (loading) {
            loadRedirect().then(async () => {
                await setLoading(false);
            });
        }
    }, [loading]);

    const persistSession = async (data: any) => {
        await localStorage.setItem(
            config.LOCAL_STORE.ACCOUNT,
            JSON.stringify(data),
        );
        await localStorage.setItem(
            config.LOCAL_STORE.ROLE,
            QHelpers.string.encrypt(
                data?.user?.is_admin === 1 || data?.is_admin
                    ? GeneralConstant.user.role.super_admin
                    : GeneralConstant.user.role.user
            )
        );
    };

    const loadRedirect = async () => {
        const token = objectParams?.token;
        const isReconnect = consumeEconomicReconnectFlag();
        const hasSession = Boolean(
            QHelpers.store.getAccessToken() || QHelpers.store.getImpersonationToken()
        );

        if (token && isReconnect) {
            if (!hasSession) {
                dispatch(setToast({
                    message: t("economic.oauthMissingSession"),
                    type: config.TOAST_TYPE.ERROR,
                }));
                history.push(RouteDefine.login);
                return;
            }

            try {
                const response: ResponseInterface | any = await SetupApi.update({ economic_token: token });
                if (response?.status === config.STATUS_CODE.OK) {
                    history.push(getEconomicReconnectReturnPath());
                    return;
                }

                dispatch(setToast({
                    message: response?.data?.message || t("economic.manualUpdateError"),
                    type: config.TOAST_TYPE.ERROR,
                }));
                history.push(getSettingsEconomicPath());
            } catch {
                dispatch(setToast({
                    message: t("economic.manualUpdateError"),
                    type: config.TOAST_TYPE.ERROR,
                }));
                history.push(getSettingsEconomicPath());
            }
            return;
        }

        if (!token) {
            history.push(RouteDefine.login);
            return;
        }

        try {
            const companyResponse: ResponseInterface | any = await UserApi.getInfoCompany({ token });
            if (companyResponse?.status !== config.STATUS_CODE.OK) {
                history.push(RouteDefine.notFound);
                return;
            }

            const companyPayload = companyResponse.data.data;
            const agreementNumber = companyPayload?.agreementNumber;
            const probe: ResponseInterface | any = await UserApi.checkExistEmail({
                accountNumber: agreementNumber,
                token,
            });

            if (probe?.status !== config.STATUS_CODE.OK || probe?.data?.data == null) {
                history.push(RouteDefine.notFound, companyPayload);
                return;
            }

            const data = probe.data.data;
            if (data.needs_registration) {
                const registrationState = {
                    token: data.token || token,
                    agreementNumber: data.agreementNumber || agreementNumber,
                    company: data.company || companyPayload?.company,
                };
                saveEconomicRegistrationSession(registrationState);
                history.push(RouteDefine.register, registrationState);
                return;
            }

            await persistSession(data);
            history.push(resolveOnboardingPath(data), {
                agreementNumber: data.agreementNumber || agreementNumber,
                user: data.user || companyPayload?.user,
                company: companyPayload?.company,
            });
        } catch (err) {
            history.push(RouteDefine.login);
        }
    };

    return (<div></div>);
}
